import type {
  ComparisonDataService,
  ComparisonObject,
} from "./comparison-data-service";
import { mockRawComparisonObjects } from "./mock-data";

export class ComparisonDataServiceMock implements ComparisonDataService {
  private vizDataCallback: ((objects: ComparisonObject[]) => void) | undefined;

  async initialize(): Promise<void> {
    this.vizDataCallback?.(mockRawComparisonObjects);
  }

  onVizDataLoaded(callback: (objects: ComparisonObject[]) => void): () => void {
    this.vizDataCallback = callback;
    return () => {
      this.vizDataCallback = undefined;
    };
  }
}
